import { REACT_APP_API_URL, REACT_APP_VENDOR_API_URL } from 'config';

const dashboard = 'dashboard';
const upload = 'upload';
const userDetails = 'user_details';
const organization = 'organization';
const incentiveProgram = 'incentive_program';
const pincode = 'pin_codes';
const roles = 'roles';
const copyRole = 'copy_role';
const modulePermissions = 'module_master_details';
const rolePermissions = 'role_permission_details';
const userEvalPermissionDetails = `${REACT_APP_API_URL}/user_eval_permission_details/`;
const downloadTemplate = `${REACT_APP_API_URL}/download_augment_user_excel/`;
const updateUserLanguage = 'update_user_language';
const getTimezoneList = 'get_timezone_list';
const userRoles = 'get_user_roles_program_details';
const updateUserRoleProgramDetails = 'update_user_role_program_details';
const inputSourceFileUpload = 'input_data_file_upload';
const downloadUserTemplateBaseUrl = `${REACT_APP_API_URL}/download_augment_user_excel`;
const downloadUserTemplate = 'download_augment_user_excell';
const bulkUserBaseUrl = `${REACT_APP_API_URL}/get_user_bulk_upload_data`;
const createSuperUser = 'create_super_user';
const getProgramRoles = 'get_program_roles';
const getBankList = '';
const vendors = 'vendors';
const gstDocumentVerification = 'document-verification/gstin';
const panDocumentVerification = 'document-verification/pan';
const bankDocumentVerification = 'document-verification/bank-account';
const orgPermissionDetails = 'organisation-permission-details';
const saveOrgPermissionDetails = 'save-organisation-permission-details';
const orgPermissionList = 'organisation-permission-list';
const organizationDelete = 'delete-org';

const bulkVendorBaseUrl = 'bulk-vendor';
const bulkVendorUpload = `${REACT_APP_VENDOR_API_URL}/upload/bulk/`;
const bulkVendorResource = 'upload/bulk';
const bulkVendorSummary = `${REACT_APP_VENDOR_API_URL}/upload/bulk/summary/`;
const downloadVendorTemplate = `${REACT_APP_VENDOR_API_URL}/upload/bulk/template/`;
// need to change
// const certificate = 'certificate'

const apiEndpoint = {
  dashboard,
  upload,
  organization,
  incentiveProgram,
  pincode,
  roles,
  copyRole,
  modulePermissions,
  rolePermissions,
  userEvalPermissionDetails,
  downloadTemplate,
  updateUserLanguage,
  getTimezoneList,
  userRoles,
  updateUserRoleProgramDetails,
  inputSourceFileUpload,
  downloadUserTemplate,
  downloadUserTemplateBaseUrl,
  bulkUserBaseUrl,
  createSuperUser,
  userDetails,
  getProgramRoles,
  getBankList,
  vendors,
  gstDocumentVerification,
  panDocumentVerification,
  bankDocumentVerification,
  orgPermissionDetails,
  saveOrgPermissionDetails,
  orgPermissionList,
  organizationDelete,
  bulkVendorBaseUrl,
  bulkVendorUpload,
  downloadVendorTemplate,
  bulkVendorSummary,
  bulkVendorResource,
};

export default apiEndpoint;
